export const BREAKPOINTS = {
  HERO_IMAGE: '@media (max-width: 1630px)',
  TABLET: '@media (max-width: 1100px)',
  XXL_MOBILE: '@media (max-width: 850px)',
  XL_MOBILE: '@media (max-width: 600px)',
};
